import { render, staticRenderFns } from "./ManageNewsProcessingStatus.vue?vue&type=template&id=699c0372&scoped=true"
import script from "./ManageNewsProcessingStatus.vue?vue&type=script&lang=js"
export * from "./ManageNewsProcessingStatus.vue?vue&type=script&lang=js"
import style0 from "./ManageNewsProcessingStatus.vue?vue&type=style&index=0&id=699c0372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c0372",
  null
  
)

export default component.exports